/**  Copyright 2022 Google LLC. All Rights Reserved.
    Use of this source code is governed by an MIT-style license that
    can be found in the LICENSE file at https://angular.io/license */


import { SelectionModel } from '@angular/cdk/collections';
import { FlatTreeControl } from '@angular/cdk/tree';
import { Component, Injectable, OnInit, ViewChild, Input, Output, EventEmitter, HostListener, ElementRef } from '@angular/core';
import { MatTreeFlatDataSource, MatTreeFlattener } from '@angular/material/tree';
import { BehaviorSubject } from 'rxjs';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { FormControl, UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { CdkDragDrop } from '@angular/cdk/drag-drop';
import { CatalogService } from 'src/app/core/services/catalog.service';
import { Observable } from 'rxjs';
import { startWith, map } from 'rxjs/operators';
import { ROOT, TYPE_LAYER } from "src/app/contants";
import { config_view_map } from "src/app/model/map";
import { convertStyle } from "src/app/commons/convert";
import { SelectImageComponent } from '../select-image/select-image.component';
import { detectFileByContentType } from 'src/app/commons/common';
import { API } from 'src/app/contants/ApiContants';
import { Lightbox } from 'ngx-lightbox';
import { legendImage } from 'src/app/commons/initData';
import { ArcgisService } from 'src/app/core/services/arcgis.service';
import { DDLService } from 'src/app/core/services/ddl.service';
import * as Constants from '../../quan-tri/Constants/Constants';

// import "@angular/material/prebuilt-themes/indigo-pink.css"
/**
 * Node for to-do item
 */
export class TodoItemNode {
  id: string;
  children: TodoItemNode[];
  data: any;
  code?: string;
  name?: string;
  icon?: string;
}

export class ItemFlatNode {
  constructor(
    public expandable: boolean,
    public name: string,
    public level: number,
    public type: any,
    public id: string
  ) { }
}


/** Flat to-do item node with expandable and level information */
export class TodoItemFlatNode {
  id: string;
  code?: string;
  data?: any;
  name?: string;
  level?: number;
  expandable?: boolean;
  icon?: string;
  children?: any;
}

/**
 * The Json object for to-do list data.
 */

/**
 * Checklist database, it can build a tree structured Json object.
 * Each node in Json object represents a to-do item or a category.
 * If a node is a category, it has children items and new items can be added under the category.
 */
@Injectable()
export class ChecklistDatabase {
  dataChange = new BehaviorSubject<TodoItemNode[]>([]);

  get data(): TodoItemNode[] {
    return this.dataChange.value;
  }

  constructor() {
    this.initialize();
  }

  initialize() {
    // Build the tree nodes from Json object. The result is a list of `TodoItemNode` with nested
    //     file node as children.
    // const data = this.buildFileTree(TREE_DATA, 0);

    // Notify the change.
    // this.dataChange.next(data);
  }

  /**
   * Build the file structure tree. The `value` is the Json object, or a sub-tree of a Json object.
   * The return value is the list of `TodoItemNode`.
   */
  buildFileTree(obj: { [key: string]: any }, level: number): TodoItemNode[] {
    console.log("------obj----", obj)

    return Object.keys(obj).reduce<TodoItemNode[]>((accumulator, key) => {
      const value = obj[key];
      const node = new TodoItemNode();
      node.code = key;

      if (value != null) {
        if (typeof value === 'object') {
          node.children = this.buildFileTree(value, level + 1);
        } else {
          node.code = value;
        }
      }

      return accumulator.concat(node);
    }, []);
  }

  /** Add an item to to-do list */
  insertItem(parent: TodoItemNode, name: string) {
    if (parent.children) {
      parent.children.push({ code: name } as TodoItemNode);
      this.dataChange.next(this.data);
    }
  }

  updateItem(node: TodoItemNode, name: string) {
    node.code = name;
    this.dataChange.next(this.data);
  }
}

/**
 * @title Tree with checkboxes
 */

@Component({
  selector: 'app-tree-view-edit-map',
  templateUrl: './tree-view-edit-map.component.html',
  styleUrls: ['./tree-view-edit-map.component.scss'],
  providers: [ChecklistDatabase],
})
export class TreeViewEditMapComponent implements OnInit {
  buttons: any = Constants.BUTTONS;
  @Input() data = [];
  @Input() basemap = [];
  @Output() onAction = new EventEmitter<any>();
  @Input() view: config_view_map;
  dataTree = [];
  contextmenu: boolean = false;
  contextmenuX = 0;
  contextmenuY = 0;

  /** Map from flat node to nested node. This helps us finding the nested node to be modified */
  flatNodeMap = new Map<TodoItemFlatNode, TodoItemNode>();

  /** Map from nested node to flattened node. This helps us to keep the same object for selection */
  nestedNodeMap = new Map<TodoItemNode, TodoItemFlatNode>();

  /** A selected parent node to be inserted */
  selectedParent: TodoItemFlatNode | null = null;

  /** The new item's name */
  newItemName = '';

  treeControl: FlatTreeControl<TodoItemFlatNode>;

  treeFlattener: MatTreeFlattener<TodoItemNode, TodoItemFlatNode>;

  dataSource: MatTreeFlatDataSource<TodoItemNode, TodoItemFlatNode>;

  /** The selection for checklist */
  checklistSelection = new SelectionModel<TodoItemFlatNode>(true /* multiple */);
  wmsOutSystem: boolean = false;
  keyword = 'name';
  layerRoot = {
    data: {
      id: ROOT,
      level: 1
    }
  }

  listWMS: any[] = [];

  expansionModel = new SelectionModel<string>(true);
  validateDrop = false;
  dragging = false;
  expandTimeout: any;
  expandDelay = 1000;
  defaultWMS = "";
  wmsSelected = {};
  @ViewChild('treeEditMap') treeEditMap;
  isFresh: boolean = false;

  isExpend = {
    layer: true,
    baseMap: true
  }

  listStyle: any = [];


  @ViewChild('selectFile', { static: true }) selectFile: SelectImageComponent;
  @HostListener('document:click', ['$event'])
  clickout(event) {
    if (!this.eRef.nativeElement.contains(event.target)) {
      this.disableContextMenu();
    }
  }
  submitted: boolean = false;
  formThietLap: UntypedFormGroup;
  nodeRightClick: any;
  nodeSelected: any = {};
  wmsControl: FormControl;
  filteredWMS: Observable<any[]>;
  tableSources: any = [];
  selectedTable: any;
  legendImage: any = legendImage;
  HOST_RESOURCE = API.HOST_RESOURCE;
  arcgisFolders = [];
  listMapserver = [];
  listFeatureServer = [];

  get valFormThietLap() { return this.formThietLap.controls; }

  constructor(
    private _database: ChecklistDatabase,
    private eRef: ElementRef,
    private modalService: NgbModal,
    private formBuilder: UntypedFormBuilder,
    private catalogService: CatalogService,
    private lightbox: Lightbox,
    private arcgisService: ArcgisService,
    private ddlService: DDLService

  ) {
    this.treeFlattener = new MatTreeFlattener(
      this.transformer,
      this.getLevel,
      this.isExpandable,
      this.getChildren,
    );
    this.treeControl = new FlatTreeControl<TodoItemFlatNode>(this.getLevel, this.isExpandable);

    this.dataSource = new MatTreeFlatDataSource(this.treeControl, this.treeFlattener);

    this.formThietLap = this.formBuilder.group({
      legend_use: [false],
      layertype: [""],
      minzoom: [""],
      maxzoom: [""],
      zindex: [""],
      wmsExternal: [false],
      linkWmsExternal: [""],
      checked: [false],
      wms: [""],
      text: [""],
      tbkey: [""],
      featureServer: [null],
      mapServer: [null],
      folderArcgis: [null],
      idStyle: [""]
    })
    // _database.dataChange.subscribe(data => {
    //   let fakedata: TodoItemNode[] = this.dataTree;
    //   console.log("-------data----------", data);
    //   console.log("-------dataTree----------", this.dataTree);
    //   this.dataSource.data = fakedata;
    // });
  }
  checkrender() {
    console.log("-------render------")
  }

  openConfigView() {
    let obj = {
      key: "open_modal_confog_view_map",
    }
    this.onAction.emit(obj);
  }

  openImage(src, index: number): void {
    // open lightbox
    let listImage = [
      {
        src: `${this.HOST_RESOURCE}/${src}`,
        caption: "Ảnh",
        thumb: `${this.HOST_RESOURCE}/${src}`,
      }
    ]
    this.lightbox.open(listImage, 0, {
      showZoom: true
    });
  }

  renderTextCheckbox(text) {
    if (text.length > 30) {
      return `${text.substring(0, 30)}...`;
    } else {
      return text;
    }
  }

  getFolderArcgis() {
    this.arcgisService.getFolderArcgis().then(data => {
      this.arcgisFolders = data.folders || [];
    })
      .catch(error => {
        console.error('Error:', error);
      });
  }

  setDataTree() {

  }

  triggerChooseFile(id) {
    // this.modalService.open(id, { size: 'lg', centered: true });
    this.selectFile.getAllFolder();
    this.selectFile.openModalChooseFile();
  }

  genDataTree(items, id = null, link = 'pid') {
    return items.filter(item => item[link] === id).map(item => ({ data: { ...item }, id: item.id, children: this.genDataTree(items, item.id) }));
  }

  ngOnChanges(event) {
    if (event.data.currentValue != event.data.currentValue.previousValue) {
      this.refreshTree();
    }
  }

  refreshTree() {
    this._database.dataChange.subscribe(data => {
      let dataTree: TodoItemNode[] = this.genDataTree(this.data, ROOT);
      this.dataSource.data = dataTree;

      this.data.forEach(node => {
        if (node.type === 'folder') {
          this.expansionModel.toggle(node.id)
        }
      });

      this.treeControl.dataNodes.forEach(element => {
        if (element.data.checked && element.data.type === 'layer') {
          let obj = {
            key: "click_node",
            value: {
              ...element,
              checked: !this.checklistSelection.isSelected(element)
            }
          }
          this.onAction.emit(obj);
          this.checklistSelection.toggle(element);

        }
      });
      this.treeControl.expandAll();
    });
  }

  getLevel = (node: TodoItemFlatNode) => node.level;

  isExpandable = (node: TodoItemFlatNode) => node.expandable;

  getChildren = (node: TodoItemNode): TodoItemNode[] => node.children;

  hasChild = (_: number, _nodeData: TodoItemFlatNode) => _nodeData.expandable;

  hasNoContent = (_: number, _nodeData: TodoItemFlatNode) => _nodeData.code === '';

  /**
   * Transformer to convert nested node to flat node. Record the nodes in maps for later use.
   */
  transformer = (node: TodoItemNode, level: number) => {
    const existingNode = this.nestedNodeMap.get(node);
    const flatNode =
      existingNode && existingNode.code === node.code ? existingNode : new TodoItemFlatNode();
    flatNode.code = node.code;
    flatNode.name = node.name;
    flatNode.id = node.data.id;
    flatNode.data = node.data;
    flatNode.children = node.children;
    flatNode.level = level;
    flatNode.expandable = !!node.children?.length;
    flatNode.icon = node.icon;
    this.flatNodeMap.set(flatNode, node);
    this.nestedNodeMap.set(node, flatNode);
    return flatNode;
  };

  ngOnInit(): void {
    this.catalogService.getAllWMS().subscribe(res => {
      if (res["status"] === 200) {
        this.listWMS = res["data"];
      }
    })

    this.catalogService.getTableSource().subscribe(res => {
      if (res["status"] === 200) {
        this.tableSources = res["data"];
      }
    })
    this.getFolderArcgis();
  }

  onSelectFolder(event) {
    console.log("=======event=======", event);
    this.arcgisService.getAllLayerbyFolder(event).then(data => {
      let layers = data.services || [];
      this.listMapserver = layers.filter(item => item.type === 'MapServer');
      this.listFeatureServer = layers.filter(item => item.type === 'FeatureServer');
    })
      .catch(error => {
        console.error('Error:', error);
      });
  }

  onSelectSource(event) {
    this.selectedTable = {
      ...event,
      model: (event.model || []).map(item => {
        return {
          ...item,
          col: item.colname,
          kieu: convertStyle(item)
        }
      })
    };
    console.log("--------onSelectSource----------", this.selectedTable);
  }

  /** Whether all the descendants of the node are selected. */
  descendantsAllSelected(node: TodoItemFlatNode): boolean {
    const descendants = this.treeControl.getDescendants(node);
    const descAllSelected =
      descendants.length > 0 &&
      descendants.every(child => {
        return this.checklistSelection.isSelected(child);
      });
    return descAllSelected;
  }

  /** Whether part of the descendants are selected */
  descendantsPartiallySelected(node: TodoItemFlatNode): boolean {
    const descendants = this.treeControl.getDescendants(node);
    const result = descendants.some(child => this.checklistSelection.isSelected(child));
    return result && !this.descendantsAllSelected(node);
  }

  /** Toggle the to-do item selection. Select/deselect all the descendants node */
  todoItemSelectionToggle(node: TodoItemFlatNode): void {
    node.data.checked = !this.checklistSelection.isSelected(node);
    let obj = {
      key: "click_node",
      value: {
        ...node,
        checked: !this.checklistSelection.isSelected(node)
      }
    }

    this.onAction.emit(obj);
    this.checklistSelection.toggle(node);
    const descendants = this.treeControl.getDescendants(node);
    this.checklistSelection.isSelected(node)
      ? this.checklistSelection.select(...descendants)
      : this.checklistSelection.deselect(...descendants);

    // Force update for the parent
    descendants.forEach(element => element.data.checked = true);

    descendants.forEach(child => this.checklistSelection.isSelected(child));
    this.checkAllParentsSelection(node);
  }

  /** Toggle a leaf to-do item selection. Check all the parents to see if they changed */
  todoLeafItemSelectionToggle(node: TodoItemFlatNode): void {
    node.data.checked = !this.checklistSelection.isSelected(node);
    let obj = {
      key: "click_node",
      value: {
        ...node,
        checked: !this.checklistSelection.isSelected(node)
      }
    }
    this.onAction.emit(obj);
    this.checklistSelection.toggle(node);
    this.checkAllParentsSelection(node);
  }
  viewTable(node) {
    let obj = {
      key: "view_table",
      value: node
    }
    this.onAction.emit(obj);
  }
  /* Checks all the parents when a leaf node is selected/unselected */
  checkAllParentsSelection(node: TodoItemFlatNode): void {
    let parent: TodoItemFlatNode | null = this.getParentNode(node);
    while (parent) {
      this.checkRootNodeSelection(parent);
      parent = this.getParentNode(parent);
    }
  }

  /** Check root node checked state and change it accordingly */
  checkRootNodeSelection(node: TodoItemFlatNode): void {
    const nodeSelected = this.checklistSelection.isSelected(node);
    const descendants = this.treeControl.getDescendants(node);
    const descAllSelected =
      descendants.length > 0 &&
      descendants.every(child => {
        return this.checklistSelection.isSelected(child);
      });
    if (nodeSelected && !descAllSelected) {
      this.checklistSelection.deselect(node);
    } else if (!nodeSelected && descAllSelected) {
      this.checklistSelection.select(node);
    }
  }


  /* Get the parent node of a node */
  getParentNode(node: TodoItemFlatNode): TodoItemFlatNode | null {
    const currentLevel = this.getLevel(node);

    if (currentLevel < 1) {
      return null;
    }

    const startIndex = this.treeControl.dataNodes.indexOf(node) - 1;

    for (let i = startIndex; i >= 0; i--) {
      const currentNode = this.treeControl.dataNodes[i];

      if (this.getLevel(currentNode) < currentLevel) {
        return currentNode;
      }
    }
    return null;
  }

  /** Select the category so we can insert the new item. */
  addNewItem(node: TodoItemFlatNode) {
    const parentNode = this.flatNodeMap.get(node);
    this._database.insertItem(parentNode!, '');
    this.treeControl.expand(node);
  }

  /** Save the node to database */
  saveNode(node: TodoItemFlatNode, itemValue: string) {
    const nestedNode = this.flatNodeMap.get(node);
    this._database.updateItem(nestedNode!, itemValue);
  }

  ngAfterViewInit() {
    let that = this;
    that.treeEditMap.treeControl.expandAll();
  }

  zoomTo(node) {
    let obj = {
      key: "zoom_to",
      value: {
        ...node,
        checked: this.checklistSelection.isSelected(node)
      }
    }
    this.onAction.emit(obj);
  }

  disableContextMenu() {
    this.contextmenu = false;
  }

  onrightClick(event, node) {
    this.contextmenuX = event.clientX - 50
    this.contextmenuY = event.clientY - 250
    this.contextmenu = true;
    this.nodeRightClick = node;
    console.log("node", node);
  }

  filter(node) {
    let obj = {
      key: "filter",
      value: {
        ...node,
        checked: this.checklistSelection.isSelected(node)
      }
    }
    this.onAction.emit(obj);
  }

  getListStyle(){
    this.ddlService.getDDLStyle().subscribe({
      next: (res) =>{
        if(res["status"] === 200){
          this.listStyle = res["data"];
        }
      }
    })
  }

  openModal(content, node) {
    this.nodeSelected = node;
    console.log("-----node---------", node)
    this.getListStyle();
    if (node?.data?.layertype === 'arcgis' && node?.data?.folderArcgis) {
      this.arcgisService.getAllLayerbyFolder(node?.data?.folderArcgis).then((res) => {
        let layers = res.services || [];
        this.listMapserver = layers.filter(item => item.type === 'MapServer');
        this.listFeatureServer = layers.filter(item => item.type === 'FeatureServer');
      })
    }
    let wms = this.listWMS.find(item => item.layer === node.data.wms);
    if (wms) {
      this.defaultWMS = wms.name;
      this.wmsSelected = wms;
    }
    this.formThietLap.controls.layertype.patchValue(node?.data?.layertype);
    this.formThietLap.controls.minzoom.patchValue(node?.data?.minzoom);
    this.formThietLap.controls.maxzoom.patchValue(node?.data?.maxzoom);
    this.formThietLap.controls.zindex.patchValue(node?.data?.zindex);
    this.formThietLap.controls.wmsExternal.patchValue(node?.data?.wmsExternal);
    this.formThietLap.controls.checked.patchValue(node?.data?.checked);
    this.formThietLap.controls.text.patchValue(node?.data?.text);
    this.formThietLap.controls.tbkey.patchValue(node?.data?.tbkey);
    this.formThietLap.controls.wms.patchValue(node?.data?.wms);
    this.formThietLap.controls.legend_use.patchValue(node?.data?.legend?.use);
    this.formThietLap.controls.featureServer.patchValue(node?.data?.featureServer || null);
    this.formThietLap.controls.mapServer.patchValue(node?.data?.mapServer || null);
    this.formThietLap.controls.folderArcgis.patchValue(node?.data?.folderArcgis || null);
    this.formThietLap.controls.idStyle.patchValue(node?.data?.idStyle || null);
    this.legendImage = {
      ...this.legendImage,
      uri: node?.data?.legend?.url
    }
    this.modalService.open(content, { size: 'lg', centered: true });
  }

  saveConfig(modal) {
    let newNode = {
      ...this.nodeSelected.data,
      text: this.valFormThietLap.text.value || "",
      legend: {
        "use": this.valFormThietLap.legend_use.value || false,
        "url": this.legendImage.uri || ""
      },
      layertype: this.valFormThietLap.layertype.value || 'wms',
      wmsExternal: this.valFormThietLap.wmsExternal.value || false,
      wms: this.wmsOutSystem ? this.valFormThietLap.linkWmsExternal.value : this.valFormThietLap.wms.value,
      checked: this.valFormThietLap.checked.value || false,
      maxzoom: this.valFormThietLap.maxzoom.value || "",
      minzoom: this.valFormThietLap.minzoom.value || "",
      zindex: this.valFormThietLap.zindex.value || "",
      table: this.selectedTable?.tbname || "",
      tbkey: this.valFormThietLap.tbkey.value || "",
      display: !this.selectedTable ? { ...this.nodeSelected.data.display } : {
        cols: this.selectedTable.model,
        popup: {
          ...this.nodeSelected?.data.display?.popopup,
          cols: this.nodeSelected?.data.display?.popopup?.cols || [],
          hiddenfield: false,
          use: true
        },
        tooltip: { ...this.nodeSelected?.data?.display?.tooltip },
        viewdetail: {
          ...this.nodeSelected?.data.display?.viewdetail,
          cols: this.nodeSelected?.data.display?.viewdetail?.cols || [],
          detailExtend: null,
          use: true
        }
      },
      filter: !this.selectedTable ? { ...this.nodeSelected.data.filter } : {
        cols: this.selectedTable.model
      },
      featureServer: this.valFormThietLap.featureServer.value || null,
      mapServer: this.valFormThietLap.mapServer.value || null,
      folderArcgis: this.valFormThietLap.folderArcgis.value || null,
      idStyle: this.valFormThietLap.idStyle.value || null
    }


    let obj = {
      key: "save_config",
      node: newNode,
    }

    if (this.valFormThietLap.layertype.value === 'arcgis') {
      this.arcgisService.getAllConfigFeature(this.valFormThietLap.featureServer.value).then((res) => {
        let allField = res["fields"] || [];
        newNode["geomtype"] = res["geometryType"];
        newNode["display"] = {
          ...newNode["display"],
          cols: allField,
        }
        obj = {
          key: "save_config",
          node: newNode,
        }
        this.onAction.emit(obj);
        console.log("==========newNode=========", newNode);
      })
    } else {
      this.onAction.emit(obj);
    }
    modal.dismiss();
  }

  onSubmit(key) {

  }

  handleStyle(key){
    let obj = {
      key: `${key}_style`,
      value: this.valFormThietLap?.idStyle?.value || ""
    }
    this.onAction.emit(obj);
  }

  handleChangeWMS(event) {
    this.wmsOutSystem = !this.wmsOutSystem;
  }

  handleAction(node, key) {
    let obj = {
      key,
      node
    }
    this.onAction.emit(obj);
  }

  selectEvent(item) {
    console.log("------item----", item);
    this.wmsSelected = item;
    // do something with selected item

  }

  onChangeSearch(search: any) {

    // fetch remote data from here
    // And reassign the 'data' which is binded to 'data' property.
  }

  onFocused(e) {
    // do something
  }

  visibleNodes(): TodoItemNode[] {
    const result = [];

    function addExpandedChildren(node: TodoItemNode, expanded: string[]) {
      result.push(node);
      if (expanded.includes(node.id)) {
        node.children.map((child) => addExpandedChildren(child, expanded));
      }
    }
    this.dataSource.data.forEach((node) => {
      addExpandedChildren(node, this.expansionModel.selected);
    });
    return result;
  }

  rebuildTreeForData(data: any) {
    this.dataSource.data = data;
    this.expansionModel.selected.forEach((id) => {
      const node = this.treeControl.dataNodes.find((n) => n.id === id);
      this.treeControl.expand(node);
    });
    this.treeControl.expandAll();
  }

  dragStart() {
    this.dragging = true;
  }
  dragEnd() {
    this.dragging = false;
  }
  dragHover(node: ItemFlatNode) {
    if (this.dragging) {
      clearTimeout(this.expandTimeout);
      this.expandTimeout = setTimeout(() => {
        this.treeControl.expand(node);
      }, this.expandDelay);
    }
  }
  dragHoverEnd() {
    if (this.dragging) {
      clearTimeout(this.expandTimeout);
    }
  }


  drop(event: CdkDragDrop<string[]>) {

    // ignore drops outside of the tree
    if (!event.isPointerOverContainer) return;

    // construct a list of visible nodes, this will match the DOM.
    // the cdkDragDrop event.currentIndex jives with visible nodes.
    // it calls rememberExpandedTreeNodes to persist expand state
    const visibleNodes = this.visibleNodes();
    // const visibleNodes = this.data;

    // deep clone the data source so we can mutate it
    const changedData = JSON.parse(JSON.stringify(this.dataSource.data));


    // recursive find function to find siblings of node
    function findNodeSiblings(arr: Array<any>, id: string): Array<any> {
      let result, subResult;
      arr.forEach((item, i) => {
        if (item.id === id) {
          result = arr;
        } else if (item.children) {
          subResult = findNodeSiblings(item.children, id);
          if (subResult) result = subResult;
        }
      });
      return result;

    }

    // determine where to insert the node
    const nodeAtDest = visibleNodes[event.currentIndex];
    const newSiblings = findNodeSiblings(changedData, nodeAtDest.id);
    if (!newSiblings) return;
    const insertIndex = newSiblings.findIndex(s => s.id === nodeAtDest.id);

    // remove the node from its old place
    const node = event.item.data;
    const siblings = findNodeSiblings(changedData, node.id);
    const siblingIndex = siblings.findIndex(n => n.id === node.id);
    const nodeToInsert: TodoItemNode = siblings.splice(siblingIndex, 1)[0];
    if (nodeAtDest.id === nodeToInsert.id) return;

    // ensure validity of drop - must be same level
    const nodeAtDestFlatNode = this.treeControl.dataNodes.find((n) => nodeAtDest.id === n.id);

    if (this.validateDrop && nodeAtDestFlatNode.level !== node.level) {
      alert('Items can only be moved within the same level.');
      return;
    }


    let nodeUpdate = {
      ...nodeToInsert,
      data: {
        ...nodeToInsert.data,
        pid: nodeAtDest.data.pid
      }
    }

    // insert node 
    newSiblings.splice(insertIndex, 0, nodeUpdate);

    // rebuild tree with mutated data
    this.rebuildTreeForData(changedData);

    let obj = {
      key: "drop_item",
      data: this.dataSource.data,
    }
    this.onAction.emit(obj);
  }

  handleCreate(node, type) {
    let obj = {
      key: "create_doc",
      node,
      type
    }
    this.onAction.emit(obj);
  }

  checkTypeVal(val) {
    return detectFileByContentType(val);
  }

  changeAction(event) {
    console.log("-----changeAction------", event)
    switch (event.key) {
      case "selected_file":
        this.legendImage = event?.value?.data?.info;
        break;
      default:
        break;
    }
  }

  onrightclickRoot(event) {
    this.contextmenuX = event.clientX - 50;
    this.contextmenuY = event.clientY - 250;
    this.contextmenu = true;
    this.nodeRightClick = {
      data: {
        id: ROOT,
        level: 1,
        type: "root"
      }
    }
  }
}
